import React from 'react'
import {HeaderContext} from '@consteed/frontend/contexts/HeaderContext'

const useShrinkedHeader = () => {
    let {shrunken} = React.useContext(HeaderContext)

    return shrunken
}

export default useShrinkedHeader
